import { createNoise2D, createNoise4D } from 'simplex-noise'

function expandDay(day: Element) {
  day.classList.add('--expanded')
}

function collapseDay(day: Element) {
  day.classList.remove('--expanded')
}

function toggleDay(dayToToggle: Element, days: Array<Element>) {
  days.forEach(collapseDay)
  expandDay(dayToToggle)
}

function setupDays(days: Array<Element>) {
  days.forEach((day) => {
    const button = day.querySelector('.js-day-button')

    button?.addEventListener('click', () => toggleDay(day, days))

    if (day.classList.contains('--expanded') && window.innerWidth < 1200) {
      window.scrollTo(0, day.getBoundingClientRect().top)
    }
  })
}

const days = Array.from(document.querySelectorAll('.js-day'))
setupDays(days)

let shouldRenderGrain = false
const filmButton = document.querySelector('.js-film-toggle')
filmButton?.addEventListener('click', () => {
  shouldRenderGrain = !shouldRenderGrain
  filmButton.classList.toggle('--on', shouldRenderGrain)

  if (shouldRenderGrain) {
    setCanvasSize()
    run()
  } else {
    requestAnimationFrame(clearCanvas)
  }
})

const canvas = document.createElement('canvas')

function setCanvasSize() {
  canvas.width = window.innerWidth
  canvas.height = window.innerHeight
  canvas.style.width = `${window.innerWidth}px`
  canvas.style.height = `${window.innerHeight}px`
}

setCanvasSize()
canvas.style.position = 'fixed'
canvas.style.top = '0'
canvas.style.left = '0'
canvas.style.width = '100%'
canvas.style.height = '100%'
canvas.style.zIndex = '9998'
canvas.style.pointerEvents = 'none'
canvas.setAttribute('aria-hidden', 'true')

const ctx = canvas.getContext('2d')

function clearCanvas() {
  ctx?.clearRect(0, 0, canvas.width, canvas.height)
}

function generateImage(time = 0) {
  const ctxImage = ctx?.getImageData(0, 0, canvas.width, canvas.height)
  const data = ctxImage?.data
  const noise = createNoise4D()

  for (let y = 0; y < canvas.height; y += 1) {
    for (let x = 0; x < canvas.width; x += 4) {
      const rIndex = y * (canvas.width * 4) + x * 4
      const gIndex = y * (canvas.width * 4) + x * 4 + 1
      const bIndex = y * (canvas.width * 4) + x * 4 + 2
      const aIndex = y * (canvas.width * 4) + x * 4 + 3
      const color = noise(x, y, y, time) * 255
      const alpha = noise(x, y, x, time) * 200

      if (data) {
        data[rIndex] = color
        data[gIndex] = color
        data[bIndex] = color
        data[aIndex] = alpha
      }
    }
  }

  if (ctxImage) {
    ctx?.fillRect(0, 0, 500, 500)
    ctx?.putImageData(ctxImage, 0, 0)
  }
}

document.body.append(canvas)

function renderGrain(time = 0) {
  generateImage(time)
}

function handleResize() {
  setCanvasSize()
  if (shouldRenderGrain) {
    requestAnimationFrame(renderGrain)
  }
}

window.addEventListener('resize', handleResize)

function run(delta = 0) {
  if (delta % 2 <= 1) {
    renderGrain(delta)
  }

  if (shouldRenderGrain) {
    requestAnimationFrame(run)
  }
}
